var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTimeOff = function SvgTimeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Time-off_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.112 7.953c-15.579-3.501-28.408 5.606-32.04 19.601-3.838 14.8-.59 24.047 3.512 29.198 3.89 4.863 10.008 7.597 16.135 8 13.376.868 24.637-9.856 27.578-22.354 3.022-12.84-.36-31.117-15.185-34.445Z",
    fill: "#FF7D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.127 17.108c-9.23-2.143-18.577 3.77-20.937 13.18a34.105 34.105 0 0 0-1.228 7.338c-.11 4.355.844 8.83 3.521 12.292 2.533 3.27 6.54 5.108 10.555 5.376 8.732.585 16.092-6.623 18.016-15.002 1.977-8.633-.24-20.93-9.927-23.184Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.907 37.28a2.646 2.646 0 0 1-.388.509 2.502 2.502 0 0 1-1.761.786c1.391 1.99 6.51 9.084 6.51 9.084.715-.575 1.138-.911 1.867-1.477l-6.228-8.901Z",
    fill: "#0083D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.007 33.156c.331-3.453.629-7.093.96-10.45h-2.4c-.086.527-.628 6.944-.91 10.301a3.125 3.125 0 0 1 2.35.149Z",
    fill: "#009C6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.907 37.28c.777-1.318.48-3.29-.82-4.086l-.077-.038a3.124 3.124 0 0 0-2.327-.149l-.096.034c-1.473.619-2.116 2.724-1.277 4.13a2.792 2.792 0 0 0 2.447 1.404 2.501 2.501 0 0 0 1.761-.786c.15-.153.28-.324.389-.508Z",
    fill: "#FFC417"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Time-off_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(11.36 7.2)",
    d: "M0 0h49.95v57.6H0z"
  })))));
};
export default SvgTimeOff;